import React from 'react';
import Cookies from 'js-cookie';
import ManagementDashboardFilters from '../Management/ManagementDashboardFilters';
import OperationsProgressionView from '../Management/OperationsProgressionView';

const OperationsProgressionTab = ({ filters, onFiltersChange, onFiltersLoadingChange }) => {
  const operationsUserId = Number(Cookies.get('userId'));

  return (
    <div className="w-full pt-[5rem] pl-5 pr-5 pb-8">
      <div className="flex w-full flex-col gap-5">
        <div className="max-w-[280px]">
          <ManagementDashboardFilters
            onFiltersChange={onFiltersChange}
            onLoadingChange={onFiltersLoadingChange}
            initialProjectID={filters?.projectID}
            initialMonth={filters?.month}
          />
        </div>

        <OperationsProgressionView
          key={
            filters?.projectID != null && String(filters.projectID) !== ''
              ? Number(filters.projectID)
              : 'none'
          }
          projectID={filters?.projectID}
          operationsUserId={operationsUserId}
        />
      </div>
    </div>
  );
};

export default OperationsProgressionTab;
